var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:[
    _vm.$style.checkbox,
    { [_vm.$style.disabled]: _vm.isDisabled },
    _vm.single && _vm.$style.single,
    _vm.big && _vm.$style.big,
  ]},[_c('input',{class:_vm.$style.input,attrs:{"type":"checkbox","disabled":_vm.isDisabled},domProps:{"checked":_vm.isActive},on:{"input":function($event){return _vm.$emit('input', !_vm.isActive)}}}),(_vm.round)?_c('div',{class:_vm.$style.round},[_c('div',{class:[_vm.$style.innerRound, _vm.isActive && _vm.$style.active]})]):_c('div',{class:[_vm.$style.box, _vm.$style[_vm.color]]}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }